export default __webpack_public_path__ + "static/media/7c.675c048a.svg";